//import { Component, ViewChild, ElementRef } from '@angular/core';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IonicPage, NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Storage } from '@ionic/storage';
import { HomePage } from '../home/home';

/**
 * Generated class for the VideoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-video',
  templateUrl: 'video.html',
})
export class VideoPage {
  //@ViewChild('play_video') mVideoPlayer: ElementRef;
  //@ViewChild('play_video') mVideoPlayer: any;
  //@ViewChild("play_video") videoEl: ElementRef; // binds to #video in video.html
  //videoElement: HTMLVideoElement
  accessCode = "";
  authtoken = "";
  video = "";
  questions = [];
  chosenAnswer = "";
  isEmpty = false;
  queAlter = false;
  btnshow = false;
  vidSrc = "";

  constructor(
    public navCtrl: NavController, 
    private toastCtrl: ToastController, 
    public navParams: NavParams,    
    public http: HttpClient,  
    public actionSheetCtrl: ActionSheetController, 
    public platform: Platform, 
    public loadingCtrl: LoadingController,
    private storage: Storage,
    public global: GlobalProvider) {
      
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad VideoPage');
    //player = this.mVideoPlayer.nativeElement;
    
    
  }

  ngAfterViewInit() {
    this.storage.get('accesscode').then((val) => {
      this.accessCode = val;
      this.storage.get('Authorization').then((val1) => {
        this.authtoken = val1;
        setTimeout( () => {
          this.getVideo();
        },1500);
      });
    });
  }

  /** regiasteration upload */

  getQuestionnaire(){
    //console.log('inquestionnn');
    const httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken,
      })
    };

    this.http.get(this.global.baseUrl+"api/admin/video/question", httpOptions)//requestOpt)
      .subscribe((data:any) => {
        
          if(data.error == true){
            //console.log(data.errorList[0].description);
            this.isEmpty = true;
            //this.global.loading.dismiss();
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){
                
              }
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            this.isEmpty = false;
           // this.global.loading.dismiss();
           const questions = [];
            //data.randomQuizDTOS.forEach(function(entry,index) {
              //if(index == 0){
                questions.push(data.randomQuizDTOS);
              //}
            //});
            this.questions.push(data.randomQuizDTOS);// = questions;
            this.btnshow = true;
            /*

            const questions = [];
            data.videoDTO.quizList.forEach(function(entry,index) {
              if(index == 0){
                questions.push(entry);
              }
            });
            this.questions = questions;*/
          }
        }, error => {
        console.log(error);
        this.isEmpty = true;
        //this.global.loading.dismiss();
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        
    });
  }
  getVideo(){
    //this.global.loading.present();
    const httpOptions = {
      headers: new HttpHeaders({
        //'Content-Type':  'application/json',
        //'Accept': 'application/json',
        'Authorization':this.authtoken//'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJzRzhNUU1DayIsInNjb3BlcyI6WyJST0xFX1ZJU0lUT1IiXSwiZXhwIjoxNTQ1NDkyMDEwfQ.v4-JvO9di-g-CuP73ufk8WQYc_5dS13snRXEMD5DlI0ca4BeIf9b6W_iWyU2F7hwyKoKJ_rJODnw1yG7fG75Kg'
      })
    };

    this.http.get(this.global.baseUrl+"api/admin/video", httpOptions)//requestOpt)
      .subscribe((data:any) => {
        
          if(data.error == true){
            //console.log(data.errorList[0].description);
            this.isEmpty = true;
            //this.global.loading.dismiss();
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              if(data.errorList[0].description == 'VISITOR_INFO_NOT_FOUND'){
                
              }
              console.log('Dismissed toast!');
            });
          
            toast.present();
          }else{
            //this.isEmpty = false;
           // this.global.loading.dismiss();
            let player = <HTMLMediaElement>document.getElementById('play_video');  
            var mp4Vid = document.getElementById('mp4Source');
            (<HTMLInputElement> mp4Vid).src = data.videoDTO.fileLocation;
            console.log('src setted');
            //player.src = data.videoDTO.fileLocation;
            player.load();
            //player.play();
            
            
  
            player.oncanplay = () => {
              player.ontimeupdate = () => console.log('video time updated');
            }
            player.onended = () => {
              console.log('finished');
              this.getQuestionnaire();
            };
            //this.getQuestionnaire();
          }
        }, error => {
        console.log(error);
        this.isEmpty = true;
        //this.global.loading.dismiss();
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 5000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        
    });
  }

  mcqAnswer(questionID,answer){
    this.chosenAnswer = answer;
  }

  stopvid(){
    console.log('paused');
    let player = <HTMLMediaElement>document.getElementById('play_video');  
    player.pause();
  }

  playvid(){
    console.log('play');
    let player = <HTMLMediaElement>document.getElementById('play_video');  
    player.play();
  }
  submitAns(){
    //this.global.loading.present();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json',
        'Authorization':this.authtoken
      })
    };

    
//    console.log(postData);

    
    this.http.post(this.global.baseUrl+"api/admin/video/question/answer?verificationCode="+this.accessCode+"&answered="+this.chosenAnswer,  httpOptions)//requestOpt)
      .subscribe((data:any) => {
        console.log(data);
        
          if(data.error == true){
            //console.log(data.errorList[0].description);
            //this.global.loading.dismiss();
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast!..');
            });
          
            toast.present();
          }else{
            if(data.randomQuizDTOS == undefined){
              let toast = this.toastCtrl.create({
                message: 'Thank you for submitting your safety video answer!.',
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });
  
              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();
              this.stopvid();
              
              this.navCtrl.push(HomePage);
            }else{
              let toast = this.toastCtrl.create({
                message: 'Try again!.',
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });
  
              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
                this.playvid();
              });
            
              toast.present();

              const questions = [];
              //data.randomQuizDTOS.forEach(function(entry,index) {
                //if(index == 0){
                  this.queAlter = true;
                  questions.push(data.randomQuizDTOS);
                //}
              //});
              this.questions = questions;
            }
            
          }
        }, error => {
          //this.global.loading.dismiss();
          let toast = this.toastCtrl.create({
            message: 'Error!.',
            duration: 5000,
            position: 'bottom',
            showCloseButton:false,
            closeButtonText:'Close'
          });

          toast.onDidDismiss(() => {
            console.log('Dismissed toast');
          });
        
          toast.present();
      });
  }
  goback(){
    //console.log('back');
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/video/video.ts